export default "__VITE_ASSET__CeWOQZ1v__"